import { render } from "./StateSelect.vue?vue&type=template&id=4b8b97c4"
import script from "./StateSelect.vue?vue&type=script&lang=js"
export * from "./StateSelect.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__